import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ErrorBoundary } from "apps/commons/components/ErrorBoundary";
import { Provider as JotaiProvider } from "jotai";
import { useGtm } from "libs/analytics/useGtm";
import { DroneContext } from "libs/drone/Context";
import { usePerformanceMetric } from "libs/performances/usePerformanceMetric";
import type { FunctionComponent } from "react";
import { HelmetProvider } from "react-helmet";
import { Outlet } from "react-router";

import "../../app.css";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
        },
    },
});

const Layout: FunctionComponent = () => {
    useGtm();
    usePerformanceMetric();

    return (
        <DroneContext>
            <HelmetProvider>
                <JotaiProvider>
                    <QueryClientProvider client={queryClient}>
                        <ErrorBoundary>
                            <Outlet />
                        </ErrorBoundary>
                    </QueryClientProvider>
                </JotaiProvider>
            </HelmetProvider>
        </DroneContext>
    );
};

export default Layout;
